import React, { FC } from 'react';
import { Box, Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import clsx from 'clsx';
import { truncateString } from 'blog/utils/strings';

export interface TabPanelProps {
  title: string;
  description: string;
  image: string;
  reverse?: boolean;
}

const useStyles = makeStyles((theme: Theme) => ({
  textBlock: {
    maxHeight: '100%',
    minHeight: 384,
    position: 'relative',
    order: 2,
    [theme.breakpoints.up('md')]: {
      order: 1,
    },
    [theme.breakpoints.up('lg')]: {
      maxHeight: 384,
    },
  },
  title: {
    fontWeight: 500,
    color: theme.palette.primary.dark,
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(3),
  },
  description: {
    lineHeight: 1.8,
    paddingBottom: theme.spacing(3),
  },
  imageBlock: {
    position: 'relative',
    order: 1,
    [theme.breakpoints.up('md')]: {
      order: 2,
    },
  },
  imageWrapper: {
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    width: '100%',
    height: '100%',
    minHeight: 215,
  },
  divider: {
    maxWidth: '100%',
    height: '1px',
    backgroundColor: '#E0621E',
    margin: '40px 0 50px',
  },
  line: {
    maxWidth: '100%',
    height: 4,
    width: 262,
    backgroundColor: '#E0621E',
    marginTop: 25,
  },
  corner: {
    position: 'absolute',
    bottom: 3,
    right: 0,
    height: 48,
    width: 48,
    backgroundColor: '#f5cfbb',
    borderBottomRightRadius: '50%',
    [theme.breakpoints.up('md')]: {
      height: 96,
      width: 96,
    },
  },
}));

export const WaterLine = () => {
  const classes = useStyles();

  return <div className={classes.divider} />;
};

const WaterServiceItem: FC<TabPanelProps> = (props) => {
  const { title, description, image, reverse } = props;
  const classes = useStyles();

  return (
    <>
      <Grid container direction={reverse ? 'row-reverse' : 'row'} justifyContent="space-between" spacing={4}>
        <Grid xs={12} md={6} className={classes.textBlock} item>
          <Grid container direction="column" style={{ minHeight: '100%', position: 'relative' }} justifyContent="space-between">
            <Grid item>
              <Typography variant="h5" className={classes.title}>
                {title}
              </Typography>
              <Typography
                variant="body1"
                color="textSecondary"
                className={classes.description}
                dangerouslySetInnerHTML={{
                  __html: truncateString(description, 340),
                }}
              />
              <div className={classes.line} />
              <div className={classes.corner} />
            </Grid>
          </Grid>
        </Grid>
        <Grid xs={12} md={6} className={clsx(classes.imageBlock)} item>
          <Box className={classes.imageWrapper} style={{ backgroundImage: `url("${image}")` }} />
        </Grid>
      </Grid>
      <Box mt={6} />
    </>
  );
};

export default WaterServiceItem;
